import { render, staticRenderFns } from "./VTable.vue?vue&type=template&id=6f119edc"
import script from "./VTable.vue?vue&type=script&lang=js"
export * from "./VTable.vue?vue&type=script&lang=js"
import style0 from "./VTable.vue?vue&type=style&index=0&id=6f119edc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports